// src/pages/admin/wrappers.tsx
import { useParams } from 'react-router-dom'
import PermissionsManager from '@/features/permissions/components/permissions'
import UserEditForm from '@/features/users/components/edit_user'
// import ClientPermissions from '@/features/permissions/components/permissionClients'

export function PermissionsManagerWrapper() {
  const { id = '' } = useParams()
  return <PermissionsManager id_user={id} />
}

export function UserEditWrapper() {
  const { id = '' } = useParams()
  return <UserEditForm id_user={id} />
}

// export function ClientPermissionsWrapper() {
//   const { id = '' } = useParams()
//   return <ClientPermissions selectedUser={id} />
// }
